import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';
import appAjax from '../helpers/ajax';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';

export default function ModalMaps(props) {
  const [elModal, setElModal] = useState(null);

  useEffect(() => {
    var tmp = $('#web_modal_maps');
    var iframe = tmp.find('iframe');

    //-- Get lat lng from props if available
    if (props.location && props.location.lat && props.location.lng) {
        var lat = props.location.lat;
        var lng = props.location.lng;
        var zoom = props.location.zoom || 16;
    } else {
        var lat = -6.9896527;
        var lng = 110.4204971;
        var zoom = 12;
    }

    //-- Put pin on the map
    var src = `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;
    iframe.attr('src', src);
  }, [props.location]);

  useEffect(() => {
    var tmp = $('#web_modal_maps');
    setElModal(tmp);

    $(tmp).on('shown.bs.modal', () => {
        
    });
  }, []);

  return (
    <div
      className="modal"
      style={{ display: "none" }}
      tabIndex={-1}
      id="web_modal_maps"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fa fa-map-marker me-1"></i> Maps</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>    
          <div className="modal-body p-0">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387190.2799148148!2d-74.25987368776953!3d40.69767006376944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c250b9e7a9b8b%3A0x9c5b8e7a9b8b8b8!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1616161616161" width="100%" height="450" style={{border: 0}} allowFullScreen="" loading="lazy"></iframe>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-dismiss="modal"
            >
              <i className='fa fa-check-square'></i> OK
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};
